import * as React from 'react'
import { connect, ConnectedProps } from 'react-redux'
import {
  Location,
  NavigateFunction,
  useNavigate,
  useParams,
} from 'react-router-dom'

import { getTrackSharesWithContacts } from '@disco/state-management/selectors/shares'
import { getTrack } from '@disco/state-management/selectors/tracks'

import type { State } from 'types/redux'
import { Track } from 'types/track'

import DocumentHeadTags from 'components/document-head-tags'
import SendTrackConfirmation from 'components/modals/track/send'

import type { RootState } from 'store/configureStore'

interface OwnProps {
  params: {
    trackId: string
    shareId: string
  }
  navigate: NavigateFunction
  location: Location
}

function mapStateToProps(state: RootState, { params }: OwnProps) {
  const trackId = parseInt(params.trackId, 10)
  const track = getTrack(state, { id: trackId })
  const shares = getTrackSharesWithContacts(state, { id: trackId })

  return {
    track,
    shares,
    user: state.user,
  }
}

const mapDispatchToProps = {}

const connector = connect(mapStateToProps, mapDispatchToProps)

type PropsFromRedux = ConnectedProps<typeof connector>

interface ShareWithRecipient {
  recipients: Array<any>
}

type Props = PropsFromRedux &
  OwnProps & {
    shares: Record<number, ShareWithRecipient>
  }
class TrackShared extends React.Component<Props> {
  checkParams(props, params) {
    // check if params are valid to prevent futher errors and state corruption
    const { track } = props
    const share = props.shares[params.shareId]
    if (!track || !share) this._closeModal()
  }

  UNSAFE_componentWillReceiveProps(nextProps: Props) {
    this.checkParams(nextProps, this.props.params)
  }

  _closeModal = () => this.props.navigate('/')

  _shareAgain = () => {
    const { trackId } = this.props.params
    const path = `/explorer/tracks/${trackId}/share`
    this.props.navigate(path)
  }

  render() {
    const { trackId, shareId } = this.props.params
    const { track } = this.props
    const share = this.props.shares[shareId]
    if (!track || !share) return null
    const { recipients } = share

    return (
      <div>
        <DocumentHeadTags title="Track sent | DISCO" />
        <SendTrackConfirmation
          track={track}
          location={this.props.location}
          recipients={recipients}
          onClose={this._closeModal}
          onShareAgain={this._shareAgain}
        />
      </div>
    )
  }
}

const ConnectedTrackShared = connector(TrackShared)

function TrackSharedWithNavigation(props: any) {
  const navigate = useNavigate()
  const params = useParams<{ trackId: string; shareId: string }>()
  return <ConnectedTrackShared {...props} navigate={navigate} params={params} />
}

export default TrackSharedWithNavigation
